export default "__VITE_ASSET__bd5d5d80__"